
export const LOYALTY_TIER_CONFIG: Record<string, { bgColor: string; textColor: string }> = {
    prive: { bgColor: 'bg-gradient-to-r from-purple-600 to-pink-600', textColor: 'text-white' },
    black: { bgColor: 'bg-gray-900', textColor: 'text-white' },
    elite: { bgColor: 'bg-gradient-to-r from-yellow-500 to-orange-500', textColor: 'text-white' },
    signature: { bgColor: 'bg-blue-600', textColor: 'text-white' },
    select: { bgColor: 'bg-teal-600', textColor: 'text-white' },
};

/**
 * Normalizes a loyalty tier string for lookup (e.g., "Privé" -> "prive").
 */
export const normalizeTierKey = (tier: string): string => {
    if (!tier) return '';
    return tier.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

/**
 * Gets the style configuration for a loyalty tier.
 */
export const getLoyaltyTierStyle = (tier: string) => {
    if (!tier) return { bgColor: 'bg-gray-100', textColor: 'text-gray-800' };

    // Direct lookup first (case insensitive)
    let key = tier.toLowerCase();
    if (LOYALTY_TIER_CONFIG[key]) return LOYALTY_TIER_CONFIG[key];

    // Normalized lookup (handle accents like Privé -> prive)
    key = normalizeTierKey(tier);
    if (LOYALTY_TIER_CONFIG[key]) return LOYALTY_TIER_CONFIG[key];

    // Default fallback
    return { bgColor: 'bg-gray-100', textColor: 'text-gray-800' };
};
